import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Briefcase, Calendar } from 'lucide-react';

const Experience = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const experiences = [
    {
      title: t.experience.roles.gfo.title,
      company: t.experience.roles.gfo.company,
      period: t.experience.roles.gfo.period,
      desc: t.experience.roles.gfo.desc,
      current: true
    },
    {
      title: t.experience.roles.kvno.title,
      company: t.experience.roles.kvno.company,
      period: t.experience.roles.kvno.period,
      desc: t.experience.roles.kvno.desc,
      current: false
    },
    {
      title: t.experience.roles.dci.title,
      company: t.experience.roles.dci.company,
      period: t.experience.roles.dci.period,
      desc: t.experience.roles.dci.desc,
      current: false
    },
    {
      title: t.experience.roles.telespazio.title,
      company: t.experience.roles.telespazio.company,
      period: t.experience.roles.telespazio.period,
      desc: t.experience.roles.telespazio.desc,
      current: false
    },
    {
      title: t.experience.roles.fastweb.title,
      company: t.experience.roles.fastweb.company,
      period: t.experience.roles.fastweb.period,
      desc: t.experience.roles.fastweb.desc,
      current: false
    }
  ];

  return (
    <section id="experience" className="brutalist-section">
      <div className="brutalist-container">
        <div data-reveal="out" className="grid md:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div>
            <p className="brutalist-kicker">{t.experience.title}</p>
            <h2 className="brutalist-title mt-4">{t.experience.subtitle}</h2>
          </div>

          <div className="relative">
            <div className="absolute left-4 top-0 bottom-0 w-px bg-border hidden sm:block" aria-hidden="true"></div>

            <div className="space-y-6">
              {experiences.map((exp, index) => (
                <div key={index} className="relative sm:pl-12">
                  <div
                    className={
                      'absolute left-[9px] top-6 h-3 w-3 rounded-full border border-foreground hidden sm:block ' +
                      (exp.current ? 'bg-foreground' : 'bg-background')
                    }
                    aria-hidden="true"
                  ></div>

                  <div
                    data-reveal="out"
                    style={{ '--reveal-delay': `${index * 70}ms` }}
                    className="brutalist-card p-6 transition-colors duration-100 ease-linear hover:bg-muted hover:border-accent"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex items-start gap-4">
                        <div className="h-12 w-12 border border-foreground bg-accent text-accent-foreground flex items-center justify-center flex-shrink-0">
                          <Briefcase className="w-6 h-6" />
                        </div>
                        <div>
                          <h3 className="font-mono tracking-[0.08em] text-xl font-semibold">
                            {exp.title}
                          </h3>
                          <p className="mt-1 font-medium text-muted-foreground">{exp.company}</p>
                        </div>
                      </div>

                      {exp.current && (
                        <span className="font-mono text-xs tracking-[0.18em] border border-foreground px-3 py-1">
                          {t.experience.present}
                        </span>
                      )}
                    </div>

                    <div className="mt-4 flex items-center text-muted-foreground text-sm font-mono tracking-[0.14em]">
                      <Calendar className="w-4 h-4 mr-2" />
                      {exp.period}
                    </div>
                    <p className="mt-4 leading-relaxed text-muted-foreground">
                      {exp.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
